/*
 * <omosa-cart-recommendations>: complementary products in the cart drawer or the light
 * confirmation (snippets/cart-drawer-content.liquid, snippets/cart-notification.liquid).
 * Fetched only once the drawer or the confirmation is shown, not on every page view.
 * No products or an error: nothing shown. Shopify is asked for more products than shown (excluded
 * tags are skipped by the section): data-limit keeps the number wanted.
 */
class OmosaCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.load();
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async load() {
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const list = doc.querySelector('.cart-recommendations');
      if (!list) return;
      const limit = Number(this.dataset.limit) || 0;
      const items = [...(list.querySelector('.cart-recommendations__cards, .cart-recommendations__list')?.children ?? [])];
      if (limit) items.slice(limit).forEach((item) => item.remove());
      // Product cards: the title sits in the list's head, next to the arrows; compact lines: above them
      const slot = list.querySelector('[data-cart-recommendations-title]');
      if (slot) {
        slot.textContent = this.dataset.title;
        this.replaceChildren(list);
      } else {
        const title = document.createElement('h3');
        title.className = 'cart-drawer__subtitle';
        title.textContent = this.dataset.title;
        this.replaceChildren(title, list);
      }
      window.OmosaScrollLoop?.prime(this); // the row loops like every row (assets/scroll-loop.js)
    } catch {
      // No recommendations: nothing shown.
    }
  }
}

if (!customElements.get('omosa-cart-recommendations')) customElements.define('omosa-cart-recommendations', OmosaCartRecommendations);
